import SettingsDashboard from './component'

export default SettingsDashboard